import Cookies from 'js-cookie';
import styles from "./RegisterEntrepeneur.module.css";
import Filler from "../../assets/Filler.jpeg";
import Logo from "../../assets/LogoPrincipal.png";
import { Link, useNavigate } from "react-router-dom";
import { Field, FieldProps, Form, Formik } from 'formik';
import * as Yup from 'yup';
import InputMask from "react-input-mask";
import CustomErrorMessage from "../../components/CustomErrorMessage/CustomErrorMessage";
import { useTranslation } from "react-i18next";
import api from "../../utils/axios/api";
import { AxiosError } from 'axios';
import { useState } from 'react';

type SignUpData = {
    name: string,
    email: string,
    password: string,
    phone: string,
    cnpj: string,
    cep: string,
    adress: string,
    adressSurname: string,
    estado: string,
    city: string
    district: string
    number: string,
    complement: string,
    occupation: string,
}

function RegisterEntrepeneur() {
    const { t } = useTranslation("", { keyPrefix: "cadastro" });
    const [noNumber, setNoNumber] = useState(false);

    const navigate = useNavigate()

    const email = Cookies.get('email') ?? ''
    const name = Cookies.get('name') ?? ''
    const picture = Cookies.get('picture') ?? undefined

    const SignupSchema = Yup.object().shape({
        name: Yup.string()
            .required(t('required')),
        email: Yup
            .string()
            .email(t('invalidEmail'))
            .required(t('required')),
        password: Yup
            .string()
            .required(t('required'))
            .min(8, 'A senha deve ter pelo menos 8 caracteres'),
        phone: Yup
            .string()
            .required(t('required'))
            .matches(/^(?:(?:\+|00)?(55)\s?)?(?:\((?:[14689][1-9]|2[12478]|3[1-8]|5[13-5]|7[134579])\)\s?)?(?:[2-8]|9[1-9])[0-9]{3}-?[0-9]{4}$/, 'Telefone inválido'),
        cnpj: Yup
            .string()
            .required(t('required')),
        cep: Yup
            .string()
            .required(t('required'))
            .matches(/^\d{5}-\d{3}$/, t('requireCEP')),
        adress: Yup
            .string()
            .required(t('required')),
        adressSurname: Yup
            .string()
            .required(t('required')),
        estado: Yup
            .string()
            .required(t('required')),
        district: Yup
            .string()
            .required(t('required')),
        city: Yup
            .string()
            .required(t('required')),
        number: Yup
            .string(),
        complement: Yup
            .string(),
        occupation: Yup
            .string()
            .required(t('required')),
    });

    async function buscaCEP(cep: string, setFieldValue: (field: string, value: string) => void) {
        if (cep.length === 9) {
            try {
                const response = await fetch(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`);
                const data = await response.json();
                if (!data.erro) {
                    setFieldValue('adress', data.logradouro);
                    setFieldValue('city', data.localidade);
                    setFieldValue('district', data.bairro)
                    setFieldValue('estado', data.uf);
                }
            } catch (error) {
                console.error('Erro ao buscar CEP:', error);
            }
        }
    }

    async function handleRegister(values: SignUpData) {
        try {
            await api.post('/user', {
                name: values.name,
                password: values.password,
                email: values.email,
                isUserDeleted: false,
                confirmedEmail: false,
                document: values.cnpj,
                documentType: 'CNPJ',
                role: 'Entrepeneur',
                image: picture,
                telephone: values.phone,
                address: {
                    state: values.estado,
                    city: values.city,
                    street: values.adress,
                    district: values.district,
                    zipCode: values.cep.replace('-', ''),
                    complement: values.complement,
                    number: values.number || null,
                    name: values.adressSurname
                },
                occupation: values.occupation
            })

            Cookies.remove('email')
            Cookies.remove('name')
            Cookies.remove('picture')

            navigate('/cadastrofinalizado')
        } catch (error) {
            if(error instanceof AxiosError && error.response.status === 409){
                alert('Documento/Email já cadastrado.')
                return
            }
            alert('Erro ao cadastrar vendedor.')
        }
    }

    return (
        <div className={styles.body}>

            <div className={styles.containerRegister}>

                <img src={Logo} className={styles.Logo} />

                <div className={styles.wrapperTop}>
                    <p>{t('haveAccount')}</p>
                    <Link className={styles.textLink} to={"/login"}>{t('Login')}</Link>
                </div>

                <h1>Cadastrar</h1>

                <Formik
                    initialValues={{
                        name,
                        email,
                        password: '',
                        phone: '',
                        cnpj: '',
                        cep: '',
                        adress: '',
                        adressSurname: '',
                        estado: '',
                        district: '',
                        city: '',
                        number: '',
                        complement: '',
                        occupation: '',
                    }}
                    validationSchema={SignupSchema}
                    validateOnChange
                    validateOnBlur
                    onSubmit={values => handleRegister(values)}
                >
                    {({ errors, touched, handleSubmit, setFieldValue, isValid, isSubmitting }) => (
                        <Form onSubmit={handleSubmit} className={styles.containerForm}>

                            <div className={styles.wrapperInput}>
                                <label htmlFor="name">{t('name')} <span className={styles.asterisco}>*</span></label>
                                <Field className={styles.input} name="name" placeholder="Ex: Maria Souza" />
                                {touched.name && errors.name && <CustomErrorMessage name="name" />}
                            </div>

                            <div className={styles.wrapperInput}>
                                <label htmlFor="email">{t('email')} <span className={styles.asterisco}>*</span></label>
                                <Field className={styles.input} name="email" type="email" placeholder="Ex: contato@empresa.com" />
                                {touched.email && errors.email && <CustomErrorMessage name="email" />}
                            </div>

                            <div className={styles.wrapperInput}>
                                <label htmlFor="password">{t('password')} <span className={styles.asterisco}>*</span></label>
                                <Field className={styles.input} name="password" type="password" placeholder="Mínimo 8 caracteres" />
                                {touched.password && errors.password && <CustomErrorMessage name="password" />}
                            </div>

                            <div className={styles.wrapperInput}>
                                <label htmlFor="phone">{t('phone')} <span className={styles.asterisco}>*</span></label>
                                <Field name="phone">
                                    {({ field }: FieldProps) => (
                                        <InputMask
                                            {...field}
                                            mask="(99) 99999-9999"
                                            className={styles.input}
                                            onChange={(e) => setFieldValue('phone', e.target.value)}
                                            placeholder="(11) 99999-9999"
                                        />
                                    )}
                                </Field>
                                {touched.phone && errors.phone && <CustomErrorMessage name="phone" />}
                            </div>

                            <div className={styles.wrapperInput}>
                                <label htmlFor="cnpj">CNPJ <span className={styles.asterisco}>*</span></label>
                                <Field name="cnpj">
                                    {({ field }: FieldProps) => (
                                        <InputMask
                                            {...field}
                                            mask="99.999.999/9999-99"
                                            className={styles.input}
                                            onChange={(e) => setFieldValue('cnpj', e.target.value)}
                                            placeholder="00.000.000/0000-00"
                                        />
                                    )}
                                </Field>
                                {touched.cnpj && errors.cnpj && <CustomErrorMessage name="cnpj" />}
                            </div>

                            <div className={styles.wrapperInput2}>
                                <div className={styles.halfInput}>
                                    <label htmlFor="cep">CEP <span className={styles.asterisco}>*</span></label>
                                    <Field name="cep">
                                        {({ field }: FieldProps) => (
                                            <InputMask
                                                {...field}
                                                mask="99999-999"
                                                className={styles.input}
                                                onChange={(e) => setFieldValue('cep', e.target.value)}
                                                placeholder="00000-000"
                                                onBlur={() => buscaCEP(field.value, setFieldValue)}
                                            />
                                        )}
                                    </Field>
                                    {touched.cep && errors.cep && <CustomErrorMessage name="cep" />}
                                </div>
                                <div className={styles.halfInput}>
                                    <label htmlFor="estado">{t('estado')} <span className={styles.asterisco}>*</span></label>
                                    <Field className={styles.input} name="estado" type="text" placeholder="Ex: SP" />
                                    {touched.estado && errors.estado && <CustomErrorMessage name="estado" />}
                                </div>
                            </div>

                            <div className={styles.wrapperInput2}>
                                <div className={styles.halfInput}>
                                    <label htmlFor="city">{t('city')} <span className={styles.asterisco}>*</span></label>
                                    <Field className={styles.input} name="city" type="text" placeholder="Ex: São Paulo" />
                                    {touched.city && errors.city && <CustomErrorMessage name="city" />}
                                </div>
                                <div className={styles.halfInput}>
                                    <label htmlFor="district">{t('district')} <span className={styles.asterisco}>*</span></label>
                                    <Field className={styles.input} name="district" type="text" placeholder="Ex: Centro" />
                                    {touched.district && errors.district && <CustomErrorMessage name="district" />}
                                </div>
                            </div>

                            <div className={styles.wrapperInput}>
                                <label htmlFor="adressSurname">{t('adressSurname')} <span className={styles.asterisco}>*</span></label>
                                <Field className={styles.input} name="adressSurname" type="text" placeholder="Ex: Matriz, Filial" />
                                {touched.adressSurname && errors.adressSurname &&
                                    <CustomErrorMessage name="adressSurname" />}
                            </div>

                            <div className={styles.wrapperInput}>
                                <label htmlFor="adress">{t('adress')} <span className={styles.asterisco}>*</span></label>
                                <Field className={styles.input} name="adress" type="text" placeholder="Ex: Av. Paulista" />
                                {touched.adress && errors.adress && <CustomErrorMessage name="adress" />}
                            </div>

                            <div className={styles.wrapperInput2}>
                                <div className={styles.halfInput}>
                                    <label htmlFor="number">{t('number')} <span className={styles.asterisco}>*</span></label>
                                    <Field
                                        className={styles.input}
                                        name="number"
                                        type="text"
                                        placeholder="Ex: 123"
                                        disabled={noNumber}
                                    />
                                    <label className={styles.noNumberToggle}>
                                        <input
                                            type="checkbox"
                                            checked={noNumber}
                                            onChange={(e) => {
                                                setNoNumber(e.target.checked);
                                                setFieldValue('number', e.target.checked ? '0' : '');
                                            }}
                                        />
                                        Sem número
                                    </label>
                                    {touched.number && errors.number && <CustomErrorMessage name="number" />}
                                </div>
                                <div className={styles.halfInput}>
                                    <label htmlFor="complement">{t('complement')}</label>
                                    <Field className={styles.input} name="complement" type="text" placeholder="Ex: Sala 5" />
                                    {touched.complement && errors.complement && <CustomErrorMessage name="complement" />}
                                </div>
                            </div>

                            <div className={styles.wrapperInput}>
                                <label htmlFor="occupation">{t('occupation')} <span className={styles.asterisco}>*</span></label>
                                <Field className={styles.input} name="occupation" placeholder="Ex: Loja de Materiais, Construtora" />
                                {touched.name && errors.name && <CustomErrorMessage name="occupation" />}
                            </div>

                            <button type="submit" disabled={!isValid || isSubmitting} className={styles.button}>
                                {isSubmitting ? t('registerLoading') : t('register')}
                            </button>

                        </Form>
                    )}
                </Formik>


            </div>

            <img src={Filler} className={styles.filler} />
        </div>
    )
}

export default RegisterEntrepeneur;
